// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"94be8a79","399":"2e983e00","449":"587b8b0d","700":"ee161176","797":"f4780464","825":"8439e7e4","840":"60569c9b","924":"4a0e40ad"}[chunkId] + ".chunk.js";
};